import { Alert } from "antd";
import React from "react";

const NoteWidget = ({ widgetConfig }: { widgetConfig: any }) => {

  const config = widgetConfig?.config;
    return (
            <div className="d-flex align-items-center justify-content-between">
                <Alert
                className="ant-alert-note"
                    description={
                        <div style={{ color: config?.color || "#000000" }}>
                            <b>{widgetConfig?.title}:</b>{" "}
                             {config?.message}
                        </div>
                    }
                    type={config?.type}
                    showIcon
                    style={{ backgroundColor: config?.backgroundColor || "#E5F8FF",
                         fontSize:config?.fontSize || "14px", 
                         padding:"10px"}}
                />
            </div>
    );
};

export default NoteWidget;
